const DashboardProjectPage = () => {
  return <>dashboard</>;
};

export default DashboardProjectPage;
